// import { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useTranslation } from 'react-i18next';

import { toggleBtnModalShortcuts } from '../../../redux/diagram/diagram.actions';
import { selectIsBtnModalShortcutsEnabled } from '../../../redux/diagram/diagram.selectors';

import { useShortKeysNavigation } from '../../../hooks/useShortKeysNavigation';

import Modal from '../Modal/Modal';
import './ModalKeyboardShortcuts.scss';


export const ModalKeyboardShortcuts = () => {
    const dispatch = useDispatch();

    const { t, i18n } = useTranslation();

    const { map: shortKeysMap } = useShortKeysNavigation();
    const isOpen = useSelector(selectIsBtnModalShortcutsEnabled);

    const handleCancel = () => {
        dispatch(toggleBtnModalShortcuts(null));
    };

    return (
        <Modal
            isOpen={isOpen}
            modalClass={`modal-keyboard-shortcuts`}
            onCancel={handleCancel}
        >
            <div className="modal-content-header">{t('m_keyboard_shortcuts.title')}</div>
            <div className="modal-content-body">

                <div className="shortcuts_section_wrap">

                    {/* Controls Left */}
                    <div className='shortcuts_section first'>
                        <div className='shortcuts_title'>
                            <div className='shortcuts_title_text'>
                                <span>{t('m_keyboard_shortcuts.ctrl_left.title1')}&nbsp;</span>
                                <span>{t('m_keyboard_shortcuts.ctrl_left.title2')}</span>
                            </div>
                            <img className="shortcuts_title_img" src="/controls_left.png" />
                        </div>
                        <div className='shortcuts_item'>
                            <div className='shortcuts_item_name'>{t('m_keyboard_shortcuts.ctrl_left.items.mouse_sel')}</div>
                            <div className='shortcuts_item_key'>
                                <span>V</span>
                            </div>
                        </div>
                        <div className='shortcuts_item'>
                            <div className='shortcuts_item_name'>{t('m_keyboard_shortcuts.ctrl_left.items.table')}</div>
                            <div className='shortcuts_item_key'>
                                <span>T</span>
                            </div>
                        </div>
                        <div className='shortcuts_item'>
                            <div className='shortcuts_item_name'>{t('m_keyboard_shortcuts.ctrl_left.items.line')}</div>
                            <div className='shortcuts_item_key'>
                                <span>L</span>
                            </div>
                        </div>
                        <div className='shortcuts_item'>
                            <div className='shortcuts_item_name'>{t('m_keyboard_shortcuts.ctrl_left.items.area')}</div>
                            <div className='shortcuts_item_key'>
                                <span>A</span>
                            </div>
                        </div>
                        <div className='shortcuts_item'>
                            <div className='shortcuts_item_name'>{t('m_keyboard_shortcuts.ctrl_left.items.note')}</div>
                            <div className='shortcuts_item_key'>
                                <span>N</span>
                            </div>
                        </div>
                        <div className='shortcuts_item'>
                            <div className='shortcuts_item_name'>{t('m_keyboard_shortcuts.ctrl_left.items.comment')}</div>
                            <div className='shortcuts_item_key'>
                                <span>C</span>
                            </div>
                        </div>
                        <div className='shortcuts_item'>
                            <div className='shortcuts_item_name'>{t('m_keyboard_shortcuts.ctrl_left.items.pen')}</div>
                            <div className='shortcuts_item_key'>
                                <span>P</span>
                            </div>
                        </div>
                        <div className='shortcuts_item'>
                            <div className='shortcuts_item_name'>{t('m_keyboard_shortcuts.ctrl_left.items.undo')}</div>
                            <div className='shortcuts_item_key'>
                                <span>{shortKeysMap?.CTRL} + Z</span>
                            </div>
                        </div>
                        <div className='shortcuts_item'>
                            <div className='shortcuts_item_name'>{t('m_keyboard_shortcuts.ctrl_left.items.redo')}</div>
                            <div className='shortcuts_item_key'>
                                <span>{shortKeysMap?.CTRL} + Shift + Z</span>
                            </div>
                        </div>
                    </div>


                    {/* Controls Top Left */}
                    <div className='shortcuts_section'>
                        <div className='shortcuts_title'>
                            <div className='shortcuts_title_text'>
                                <span>{t('m_keyboard_shortcuts.ctrl_top_left.title1')}&nbsp;</span>
                                <span>{t('m_keyboard_shortcuts.ctrl_top_left.title2')}</span>
                            </div>
                            <img className="shortcuts_title_img" src="/controls_top_left.png" />
                        </div>
                        <div className='shortcuts_item'>
                            <div className='shortcuts_item_name'>{t('m_keyboard_shortcuts.ctrl_top_left.items.export_img')}</div>
                            <div className='shortcuts_item_key'>
                                <span>E</span>
                            </div>
                        </div>
                        <div className='shortcuts_item'>
                            <div className='shortcuts_item_name'>{t('m_keyboard_shortcuts.ctrl_top_left.items.search')}</div>
                            <div className='shortcuts_item_key'>
                                <span>{shortKeysMap?.CTRL} + F</span>
                                <span>F</span>
                            </div>
                        </div>
                        <div className='shortcuts_item'>
                            <div className='shortcuts_item_name'>{t('m_keyboard_shortcuts.ctrl_top_left.items.editor_panel')}</div>
                            <div className='shortcuts_item_key'>
                                <span>B</span>
                            </div>
                        </div>
                    </div>


                    {/* Controls Bottom Right */}
                    <div className='shortcuts_section'>
                        <div className='shortcuts_title'>
                            <div className='shortcuts_title_text'>
                                <span>{t('m_keyboard_shortcuts.ctrl_bottom_right.title1')}&nbsp;</span>
                                <span>{t('m_keyboard_shortcuts.ctrl_bottom_right.title2')}</span>
                            </div>
                            <img className="shortcuts_title_img" src="/controls_bottom_right.png" />
                        </div>
                        <div className='shortcuts_item'>
                            <div className='shortcuts_item_name'>{t('m_keyboard_shortcuts.ctrl_bottom_right.items.minimap')}</div>
                            <div className='shortcuts_item_key'>
                                <span>M</span>
                            </div>
                        </div>
                        <div className='shortcuts_item'>
                            <div className='shortcuts_item_name'>{t('m_keyboard_shortcuts.ctrl_bottom_right.items.zoom_in')}</div>
                            <div className='shortcuts_item_key'>
                                <span>{shortKeysMap?.CTRL} +</span>
                            </div>
                        </div>
                        <div className='shortcuts_item'>
                            <div className='shortcuts_item_name'>{t('m_keyboard_shortcuts.ctrl_bottom_right.items.zoom_out')}</div>
                            <div className='shortcuts_item_key'>
                                <span>{shortKeysMap?.CTRL} -</span>
                            </div>
                        </div>
                        <div className='shortcuts_item'>
                            <div className='shortcuts_item_name'>{t('m_keyboard_shortcuts.ctrl_bottom_right.items.zoom_100')}</div>
                            <div className='shortcuts_item_key'>
                                <span>{shortKeysMap?.CTRL} + 0</span>
                            </div>
                        </div>
                    </div>



                    {/* Context Menu Table */}
                    <div className='shortcuts_section'>
                        <div className='shortcuts_title'>
                            <div className='shortcuts_title_text long'>
                                <span>{t('m_keyboard_shortcuts.ctx_tab.title1')}&nbsp;</span>
                                <span>{t('m_keyboard_shortcuts.ctx_tab.title2')}</span>
                            </div>
                            <img className="shortcuts_title_img" src="/context_menu_table.png" />
                        </div>
                        {/* <div className='shortcuts_item'>
                            <div className='shortcuts_item_name'>Add description</div>
                            <div className='shortcuts_item_key'>
                                <span>{shortKeysMap?.CTRL} + D</span>
                            </div>
                        </div> */}
                        <div className='shortcuts_item'>
                            <div className='shortcuts_item_name'>{t('m_keyboard_shortcuts.ctx_tab.items.dupl_tab')}</div>
                            <div className='shortcuts_item_key'>
                                <span>{shortKeysMap?.CTRL} + C</span>
                            </div>
                        </div>
                        <div className='shortcuts_item'>
                            <div className='shortcuts_item_name'>{t('m_keyboard_shortcuts.ctx_tab.items.del_tab')}</div>
                            <div className='shortcuts_item_key'>
                                <span>Del</span>
                            </div>
                        </div>
                    </div>



                    {/* Context Menu Delete Table */}
                    <div className='shortcuts_section'>
                        <div className='shortcuts_title'>
                            <div className='shortcuts_title_text'>
                                <span>{t('m_keyboard_shortcuts.ctx_del_tab.title1')}&nbsp;</span>
                                <span>{t('m_keyboard_shortcuts.ctx_del_tab.title2')}</span>
                            </div>
                            <img className="shortcuts_title_img" src="/context_menu_table_delete.png" />
                        </div>
                        <div className='shortcuts_item'>
                            <div className='shortcuts_item_name'>{t('m_keyboard_shortcuts.ctx_del_tab.items.yes')}</div>
                            <div className='shortcuts_item_key'>
                                <span>Enter</span>
                            </div>
                        </div>
                        <div className='shortcuts_item'>
                            <div className='shortcuts_item_name'>{t('m_keyboard_shortcuts.ctx_del_tab.items.no')}</div>
                            <div className='shortcuts_item_key'>
                                <span>Esc</span>
                            </div>
                        </div>
                    </div>




                    {/* Context Menu Table Column */}
                    <div className='shortcuts_section'>
                        <div className='shortcuts_title'>
                            <div className='shortcuts_title_text long long-d'>
                                <span>{t('m_keyboard_shortcuts.ctx_tab_col.title1')}&nbsp;</span>
                                <span>{t('m_keyboard_shortcuts.ctx_tab_col.title2')}</span>
                            </div>
                            <img className="shortcuts_title_img" src="/context_menu_column.png" />
                        </div>
                        <div className='shortcuts_item'>
                            <div className='shortcuts_item_name'>{t('m_keyboard_shortcuts.ctx_tab_col.items.add_col_below')}</div>
                            <div className='shortcuts_item_key'>
                                <span>{shortKeysMap?.CTRL} + Enter</span>
                            </div>
                        </div>

                        <div className='shortcuts_item'>
                            <div className='shortcuts_item_name'>{t('m_keyboard_shortcuts.ctx_tab_col.items.focus_col_above')}</div>
                            <div className='shortcuts_item_key'>
                                <span>{shortKeysMap?.CTRL} + Up</span>
                            </div>
                        </div>
                        <div className='shortcuts_item'>
                            <div className='shortcuts_item_name'>{t('m_keyboard_shortcuts.ctx_tab_col.items.focus_col_below')}</div>
                            <div className='shortcuts_item_key'>
                                <span>{shortKeysMap?.CTRL} + Down</span>
                            </div>
                        </div>

                        <div className='shortcuts_item'>
                            <div className='shortcuts_item_name'>{t('m_keyboard_shortcuts.ctx_tab_col.items.move_col_up')}</div>
                            <div className='shortcuts_item_key'>
                                <span>{shortKeysMap?.CTRL} + Shift + Up</span>
                            </div>
                        </div>
                        <div className='shortcuts_item'>
                            <div className='shortcuts_item_name'>{t('m_keyboard_shortcuts.ctx_tab_col.items.move_col_down')}</div>
                            <div className='shortcuts_item_key'>
                                <span>{shortKeysMap?.CTRL} + Shift + Down</span>
                            </div>
                        </div>
                        {/* <div className='shortcuts_item'>
                            <div className='shortcuts_item_name'>Add description</div>
                            <div className='shortcuts_item_key'>
                                <span>{shortKeysMap?.CTRL} + D</span>
                            </div>
                        </div> */}
                        <div className='shortcuts_item'>
                            <div className='shortcuts_item_name'>{t('m_keyboard_shortcuts.ctx_tab_col.items.dupl_col')}</div>
                            <div className='shortcuts_item_key'>
                                <span>{shortKeysMap?.CTRL} + C</span>
                            </div>
                        </div>
                        <div className='shortcuts_item'>
                            <div className='shortcuts_item_name'>{t('m_keyboard_shortcuts.ctx_tab_col.items.del_col')}</div>
                            <div className='shortcuts_item_key'>
                                <span>{shortKeysMap?.CTRL} + Del</span>
                            </div>
                        </div>
                    </div>




                    {/* Context Menu Line */}
                    <div className='shortcuts_section'>
                        <div className='shortcuts_title'>
                            <div className='shortcuts_title_text long '>
                                <span>{t('m_keyboard_shortcuts.ctx_line.title1')}&nbsp;</span>
                                <span>{t('m_keyboard_shortcuts.ctx_line.title2')}</span>
                            </div>
                            <img className="shortcuts_title_img" src="/context_menu_line.png" />
                        </div>
                        {/* <div className='shortcuts_item'>
                            <div className='shortcuts_item_name'>Add description</div>
                            <div className='shortcuts_item_key'>
                                <span>{shortKeysMap?.CTRL} + D</span>
                            </div>
                        </div> */}
                        <div className='shortcuts_item'>
                            <div className='shortcuts_item_name'>{t('m_keyboard_shortcuts.ctx_line.items.del_line')}</div>
                            <div className='shortcuts_item_key'>
                                <span>Del</span>
                            </div>
                        </div>
                    </div>




                    {/* Context Menu Area */}
                    <div className='shortcuts_section'>
                        <div className='shortcuts_title'>
                            <div className='shortcuts_title_text long'>
                                <span>{t('m_keyboard_shortcuts.ctx_area.title1')}&nbsp;</span>
                                <span>{t('m_keyboard_shortcuts.ctx_area.title2')}</span>
                            </div>
                            <img className="shortcuts_title_img" src="/context_menu_area.png" />
                        </div>
                        {/* <div className='shortcuts_item'>
                            <div className='shortcuts_item_name'>Add description</div>
                            <div className='shortcuts_item_key'>
                                <span>{shortKeysMap?.CTRL} + D</span>
                            </div>
                        </div> */}
                        <div className='shortcuts_item'>
                            <div className='shortcuts_item_name'>{t('m_keyboard_shortcuts.ctx_area.items.dupl_area')}</div>
                            <div className='shortcuts_item_key'>
                                <span>{shortKeysMap?.CTRL} + C</span>
                            </div>
                        </div>
                        <div className='shortcuts_item'>
                            <div className='shortcuts_item_name'>{t('m_keyboard_shortcuts.ctx_area.items.del_area')}</div>
                            <div className='shortcuts_item_key'>
                                {/* <span>{shortKeysMap?.CTRL} + Del</span> */}
                                <span>Del</span>
                            </div>
                        </div>
                    </div>



                    {/* Context Menu Multiselect Elements */}
                    <div className='shortcuts_section'>
                        <div className='shortcuts_title'>
                            <div className='shortcuts_title_text long'>
                                <span>{t('m_keyboard_shortcuts.ctx_multi.title1')}&nbsp;</span>
                                <span>{t('m_keyboard_shortcuts.ctx_multi.title2')}</span>
                            </div>
                            <img className="shortcuts_title_img" src="/context_menu_multiselect.png" />
                        </div>
                        <div className='shortcuts_item'>
                            <div className='shortcuts_item_name'>{t('m_keyboard_shortcuts.ctx_multi.items.select_all')}</div>
                            <div className='shortcuts_item_key'>
                                <span>{shortKeysMap?.CTRL} + A</span>
                            </div>
                        </div>
                        <div className='shortcuts_item'>
                            <div className='shortcuts_item_name'>{t('m_keyboard_shortcuts.ctx_multi.items.create_area_for_select_els')}</div>
                            <div className='shortcuts_item_key'>
                                <span>A</span>
                            </div>
                        </div>
                        <div className='shortcuts_item'>
                            <div className='shortcuts_item_name'>{t('m_keyboard_shortcuts.ctx_multi.items.dupl_select_els')}</div>
                            <div className='shortcuts_item_key'>
                                <span>{shortKeysMap?.CTRL} + C</span>
                            </div>
                        </div>
                        <div className='shortcuts_item'>
                            <div className='shortcuts_item_name'>{t('m_keyboard_shortcuts.ctx_multi.items.del_select_els')}</div>
                            <div className='shortcuts_item_key'>
                                {/* <span>{shortKeysMap?.CTRL} + Del</span> */}
                                <span>Del</span>
                            </div>
                        </div>
                    </div>

                </div>


                <div className='button_wrap'>
                    <button
                        // disabled={!value}
                        onClick={() => handleCancel()}
                    >{t('b.close')}</button>
                </div>
            </div>
        </Modal>
    );
};

export default ModalKeyboardShortcuts;
